import styled from 'styled-components';
import LoaderSkelton from '@tcp/core/src/components/common/molecules/LoaderSkelton';

export const SkeletonWrapper = styled.div`
  border-radius: 16px;
  margin: 0 15px 16px 16px;

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    margin: 5px 0px 8px;
    height: 173.59px;
  }
`;

export const StyledLoader = styled(LoaderSkelton)`
  width: 100%;
  height: 175.19px;

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    height: 173.59px;
  }
`;
